const opts = { style: 'currency', currency: 'GBP' };
const toCurrency = new Intl.NumberFormat('en-GB', opts);

export default (pounds, { hidePence } = {}) => {
    let currencyStr = toCurrency.format(pounds);
    if (hidePence) currencyStr = currencyStr.slice(0, -3);
    return currencyStr;
};
